import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  max-width: 150px;
  color: ${({ hasErrors = false }) => (hasErrors ? 'yellow' : 'inherited')};
`;
